import { useRef, useEffect } from 'react';

// Простая шина событий для коммуникации между компонентами
class EventBus {
  constructor() {
    this.listeners = {};
  }

  on(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
    
    // Возвращаем функцию отписки
    return () => {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
      if (this.listeners[event].length === 0) {
        delete this.listeners[event];
      }
    };
  }

  emit(event, data) {
    const callbacks = this.listeners[event] || [];
    callbacks.forEach(callback => {
      try {
        callback(data);
      } catch (error) {
        console.error(`Ошибка в обработчике события ${event}:`, error);
      }
    });
  }

  once(event, callback) {
    const unsubscribe = this.on(event, (data) => {
      unsubscribe();
      callback(data);
    });
    return unsubscribe;
  }

  removeAllListeners(event) {
    if (event) {
      delete this.listeners[event];
    } else {
      this.listeners = {};
    }
  }
}

// Экспортируем синглтон
export const dataEvents = new EventBus();

// Типы событий
export const EVENTS = {
  // Сотрудники
  EMPLOYEE_CREATED: 'employee_created',
  EMPLOYEE_UPDATED: 'employee_updated',
  EMPLOYEE_DELETED: 'employee_deleted',
  
  // Должности
  POSITION_CREATED: 'position_created',
  POSITION_UPDATED: 'position_updated',
  POSITION_DELETED: 'position_deleted',
  
  // Бригады
  BRIGADE_CREATED: 'brigade_created',
  BRIGADE_UPDATED: 'brigade_updated',
  BRIGADE_DELETED: 'brigade_deleted',
  
  // Курсы/Обучения
  COURSE_CREATED: 'course_created',
  COURSE_UPDATED: 'course_updated',
  COURSE_DELETED: 'course_deleted',
  
  // Назначения обучений
  TRAINING_ASSIGNED: 'training_assigned',
  TRAINING_COMPLETED: 'training_completed',
  TRAINING_EXTENDED: 'training_extended',
  TRAINING_DELETED: 'training_deleted',
  TRAINING_STATUS_CHANGED: 'training_status_changed',
  
  // Матрица
  MATRIX_UPDATED: 'matrix_updated',
  
  // Общие
  ALL_DATA_CHANGED: 'all_data_changed',
  CACHE_INVALIDATED: 'cache_invalidated'
};

// Хук для подписки на события
export const useDataEvent = (event, handler) => {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;
  
  useEffect(() => {
    const unsubscribe = dataEvents.on(event, (data) => {
      if (handlerRef.current) {
        handlerRef.current(data);
      }
    });
    
    return unsubscribe;
  }, [event]);
};

// Хук для подписки на несколько событий
export const useDataEvents = (eventsMap) => {
  useEffect(() => {
    const unsubscribers = Object.entries(eventsMap).map(([event, handler]) => {
      return dataEvents.on(event, handler);
    });
    
    return () => {
      unsubscribers.forEach(unsub => unsub());
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};